import { LanguageProvider } from '@/contexts/LanguageContext';
import GoldPriceTicker from '@/components/GoldPriceTicker';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from './Home';

const Index = () => {
  return (
    <LanguageProvider lang="ar">
      <div className="min-h-screen flex flex-col">
        <GoldPriceTicker />
        <Header />
        <main className="flex-1">
          <Home />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default Index;
